
import { Button } from "@/components/ui/button";
import { useState } from "react";

interface ProfileBioProps {
  bio: string | null;
}

export const ProfileBio = ({ bio }: ProfileBioProps) => {
  const [isFullBio, setIsFullBio] = useState(false);
  const MAX_BIO_LENGTH = 150;

  if (!bio) return null;

  const shouldTruncateBio = bio.length > MAX_BIO_LENGTH;
  const displayedBio = shouldTruncateBio && !isFullBio 
    ? `${bio.slice(0, MAX_BIO_LENGTH)}...`
    : bio;

  return (
    <div className="mb-6 bg-gray-50 p-4 rounded-lg">
      <p className="text-gray-700">
        {displayedBio}
      </p>
      {shouldTruncateBio && (
        <Button
          variant="link"
          onClick={() => setIsFullBio(!isFullBio)}
          className="mt-2 p-0 h-auto font-medium"
        >
          {isFullBio ? "Show less" : "Show more"}
        </Button>
      )}
    </div>
  );
};
